export default __webpack_public_path__ + "static/media/光的方向.df917248.mp3";